import { z } from 'zod';

/**
 * Phase 5B.2 — Per-scenario review assignees.
 * Backed by `quality_scenario_review_reviewers` (migration 204).
 * Pattern mirrors `flow-review-reviewers.ts` without sharing tables.
 */

export const ScenarioReviewerRoleSchema = z.enum(['required', 'optional']);
export type ScenarioReviewerRole = z.infer<typeof ScenarioReviewerRoleSchema>;

export const ScenarioReviewReviewerSchema = z.object({
  reviewId: z.string().uuid(),
  userId: z.string().uuid(),
  userName: z.string(),
  role: ScenarioReviewerRoleSchema,
  invitedBy: z.string().uuid().nullable(),
  invitedByName: z.string().nullable(),
  invitedAt: z.string(),
  removedAt: z.string().nullable(),
  /** Phase 5B.3 — latest vote from quality_scenario_review_decisions, if any. */
  decision: z.enum(['approved', 'changes_requested']).nullable().optional(),
  decidedAt: z.string().nullable().optional(),
});
export type ScenarioReviewReviewer = z.infer<typeof ScenarioReviewReviewerSchema>;

export const AddScenarioReviewerBodySchema = z.object({
  userId: z.string().uuid(),
  role: ScenarioReviewerRoleSchema.default('required'),
});
export type AddScenarioReviewerBody = z.infer<typeof AddScenarioReviewerBodySchema>;

export const ListScenarioReviewersResponseSchema = z.object({
  reviewers: z.array(ScenarioReviewReviewerSchema),
});
export type ListScenarioReviewersResponse = z.infer<typeof ListScenarioReviewersResponseSchema>;

export const ScenarioReviewInboxBucketSchema = z.enum(['assigned_to_me', 'requested_by_me']);
export type ScenarioReviewInboxBucket = z.infer<typeof ScenarioReviewInboxBucketSchema>;

export const ScenarioReviewInboxItemSchema = z.object({
  reviewId: z.string().uuid(),
  scenarioId: z.string().uuid(),
  scenarioTitle: z.string(),
  projectId: z.string().uuid(),
  state: z.enum(['pending', 'approved', 'changes_requested', 'superseded']),
  snapshotVersion: z.number().int().positive(),
  requestedBy: z.string().uuid(),
  requestedByName: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  bucket: ScenarioReviewInboxBucketSchema,
});
export type ScenarioReviewInboxItem = z.infer<typeof ScenarioReviewInboxItemSchema>;

export const ScenarioReviewInboxResponseSchema = z.object({
  items: z.array(ScenarioReviewInboxItemSchema),
});
export type ScenarioReviewInboxResponse = z.infer<typeof ScenarioReviewInboxResponseSchema>;
